export default class DataMessage {
    constructor(subtype, source, details, timeStamp) {
        this.subtype = subtype;
        this.source = source;
        this.details = details;
        this.timeStamp = timeStamp;
    }
}
